module.exports = __webpack_public_path__ + "img/paste.de746fe4.svg";